<script setup lang="ts">
import VLazyImage from 'v-lazy-image'
import { toRef } from 'vue'

const props = defineProps({
  src: {
    type: String,
    require: true,
    default: '',
  },
  isHiddenPlaceholder: {
    type: Boolean,
    default: false,
  },
  imageDefault: {
    type: String,
    default: '',
  },
})
const isShowImageClient = ref(false)
const currentImageSrc = toRef(props.src)
const imageSrc = computed(() => {
  return currentImageSrc.value || props.src
})

const customClass = toRef('')
const checkImageError = (): void => {
  currentImageSrc.value = props.imageDefault || props.src
  customClass.value = 'image-error'
}
onMounted(() => {
  currentImageSrc.value = props.src
  isShowImageClient.value = true
})
watch(
  () => props.src,
  (newVal) => {
    currentImageSrc.value = newVal
  },
  { immediate: true },
)
</script>
<template>
  <div class="base-image">
    <ClientOnly v-if="isShowImageClient">
      <VLazyImage
        v-if="isHiddenPlaceholder"
        v-bind="$attrs"
        :src="imageSrc"
        loading="eager"
        fetchpriority="high"
        :class="customClass"
        @error="checkImageError"
      />
      <VLazyImage
        v-else
        v-bind="$attrs"
        :src="imageSrc"
        loading="eager"
        fetchpriority="high"
        :class="customClass"
        :src-placeholder="imageDefault || imageSrc"
        @error="checkImageError"
      />
    </ClientOnly>
    <img
      v-if="!isShowImageClient"
      v-bind="$attrs"
      :src="props.src || imageDefault"
      loading="eager"
      fetchpriority="high"
      class="image-ssr"
    />
  </div>
</template>
